<template>
  <div class="privacy-footer">
    <img class="lock-icon" :src="require('@/assets/onboarding/icons/icon-lock.svg')">
    <div class="text-wrapper">
      <span class="bold">פרטיות המידע שלך קודמת לכל. </span>
      <span>המידע שלך מאובטח תחת סטנדרט אבטחה בינלאומי.</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyFooter',
};
</script>

<style lang="scss" scoped>
  @import '../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../scss/mixins';

  .privacy-footer {
    display: flex;
    justify-content: space-between;
    width: 100%;
    @include responsive-padding;
    padding-top: 10px;
    padding-bottom: 10px;
    background-color: $riseup_light_blue;

    .lock-icon {
      margin-left: 20px;
    }

    .text-wrapper {
      flex-grow: 1;
      font-size: 14px;
      line-height: 1.36;
      color: $riseup_blue;

      .bold {
        font-weight: bold;
      }
    }
  }
</style>
